module.exports = __webpack_public_path__ + "static/img/hreart.07fc4b44.png";